export const login = {
    contentLogin: '您可以使用AIS APP账号登录',
    downloadApp: '下载应用AIS',
    downloadInstructions: '下载说明',
    buttonLogin: '登录',
    passwordLabel: '密码',
    title: '登录',
    forGetPassword: '忘记密码？',
    register: '注册',
    noAccount: '还没有账户？',
};
